import { motion } from "framer-motion"
import { StaticImage } from "gatsby-plugin-image"
import AnimatedText from "../../myne/AnimatedText/AnimatedText"
import { Chip } from "../../myne/Chip/Chip"
import useWindowDimensions from "../../utils/useWindowDimensions"
import { GDPRSection } from "../landing-page/GDPRSection"

const logos = [
  {
    name: "cvent",
    logo: (
      <StaticImage
        src="../../images/integrations/cvent.png"
        alt="cvent"
        placeholder="blurred"
        loading="lazy"
        className="w-24"
      />
    ),
  },
  {
    name: "HubSpot",
    logo: (
      <StaticImage
        src="../../images/integrations/hubspot.png"
        alt="Hubspot"
        placeholder="blurred"
        loading="lazy"
        className="w-24"
      />
    ),
  },
  {
    name: "Zoho",
    logo: (
      <StaticImage
        src="../../images/integrations/swapcard.png"
        alt="Zoho"
        placeholder="blurred"
        loading="lazy"
        className="w-24"
      />
    ),
  },
  {
    name: "WebEngage",
    logo: (
      <StaticImage
        src="../../images/integrations/grip.png"
        alt="Web Engage"
        loading="lazy"
        placeholder="blurred"
        className="w-8"
      />
    ),
  },
  {
    name: "Eventbrite",
    logo: (
      <StaticImage
        src="../../images/integrations/luma.png"
        alt="Eventbrite"
        loading="lazy"
        placeholder="blurred"
        className="w-8"
      />
    ),
  },
  {
    name: "Airmeet",
    logo: (
      <StaticImage
        src="../../images/integrations/gatsby.png"
        alt="Airmeet"
        loading="lazy"
        placeholder="blurred"
        className="w-16 md:w-20"
      />
    ),
  },
  {
    name: "Visit",
    logo: (
      <StaticImage
        src="../../images/integrations/eventify.png"
        alt="Visit"
        loading="lazy"
        placeholder="blurred"
        className="w-24"
      />
    ),
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
}

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
}

const AiIntegration = () => {
  return (
    <section className="pt-14 md:pt-20 pb-10 px-6 container mx-auto relative">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
        className="pb-8 md:pb-0"
      >
        <h2 className="text-[34px] md:text-4xl md:text-6xl font-semibold text-gray-900 mb-6 max-w-2xl">
          Works With Your Existing <AnimatedText>Event Tools</AnimatedText>
        </h2>
        <p className="text-base md:text-lg text-[#121212] max-w-3xl mb-12">
          Connect your registration platform in seconds and let the automation
          handle the rest. <br className="hidden md:block" /> We sync data
          seamlessly so your marketing runs on autopilot while you focus on the
          floor.
        </p>
        <div className="flex flex-wrap items-center gap-10">
          {logos.map((item, i) => (
            <motion.div
              key={item.name || i}
              variants={itemVariants}
              className="flex items-center shrink-0"
            >
              <div className="h-6 md:h-8 lg:h-10 w-auto flex items-center">
                {item?.logo}
              </div>
            </motion.div>
          ))}
        </div>
        <div className="mt-8 md:mt-6">
          <Chip text=" & Many More" link="/integrations" size={"md"} />
        </div>
      </motion.div>

      {/* GDPR Section */}
      <GDPRSection />

      {/* Animated Background Blobs */}
      <motion.div
        className="absolute bottom-[10%] right-0 w-[200px] h-[200px] rounded-full bg-gradient-to-br from-[#3BA1FF] to-[#62EB60] blur-3xl opacity-50 z-4 hidden md:block"
        animate={{
          x: ["0%", "-40%", "20%", "0%"],
          y: ["0%", "30%", "-20%", "0%"],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <motion.div
        className="absolute top-[50%] left-[-10%] w-[200px] h-[200px] rounded-full bg-gradient-to-tr from-[#0A91FF] via-[#908EFF] to-[#FF7AD2] blur-2xl opacity-50"
        animate={{
          x: ["0%", "40%", "-10px", "0%"],
          y: ["0%", "-20%", "40%", "0%"],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 3,
        }}
      />
      {/* blob end */}
    </section>
  )
}

export default AiIntegration
